import baseApi from "@/api/baseApi";

const api = {
  async exportTable(data) {
    const response = await baseApi({
      method: "post",
      url: `/export/table`,
      responseType: "blob",
      data: data,
    });

    return response.data;
  },
};

export default api;
